"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//tslint:disable:no-reserved-keywords
var AnnotationType;
(function (AnnotationType) {
    AnnotationType["entity"] = "entity";
    AnnotationType["intent"] = "intent";
    AnnotationType["action"] = "action";
})(AnnotationType = exports.AnnotationType || (exports.AnnotationType = {}));
//# sourceMappingURL=annotatedText.types.js.map